import { TACQ0004 } from 'growth-payments-core/experiment/Ids';
import { useIsTACQ0004Variant } from 'growth-payments-core/experiment/hooks';
import { logExposure } from 'growth-payments-core/experiment/utils';
import useFetchCRMObjects from './useFetchCRMObjects';
import { useEffect } from 'react';
export const COMMERCE_TEMPLATE_PREFIX = 'commerce-analytics';
const useCommerceCRMRecordReportZeroState = report => {
  const isInTACQ0004VariationGroup = useIsTACQ0004Variant();
  const objectTypeId = report.getIn(['config', 'objectTypeId']);
  const templateKey = report.get('templateKey');
  const isCommerceReport = templateKey === null || templateKey === void 0 ? void 0 : templateKey.includes(COMMERCE_TEMPLATE_PREFIX);
  const {
    hasCRMObjects,
    isLoading
  } = useFetchCRMObjects(objectTypeId, false);
  useEffect(() => {
    if (isCommerceReport && !isLoading && !hasCRMObjects) {
      logExposure(TACQ0004);
    }
  }, [isCommerceReport, isLoading, hasCRMObjects]);
  return {
    shouldShowZeroState: isInTACQ0004VariationGroup && hasCRMObjects === false && isCommerceReport,
    isLoading: isCommerceReport && isLoading
  };
};
export default useCommerceCRMRecordReportZeroState;